/**
 * lib/views/javascripts/head/shell.js — the head entry for the Mach33 shell
 * on every desktop page (lib/views/htmls/shell/head.ejs, written by
 * lib/vega-shell-extras.js headExtras; ADR 0082 D3, P3 lv-1).
 *
 * A head entry, not a module: the build bundles it into one classic script
 * that <head> loads with a blocking <script src>, so it runs before the body
 * parses, where the four inline scripts it replaces ran. The server's values
 * are the #m33-head-boot block written just before it.
 *
 * Contents: view
 * Ontology: Code object M33C-0729 (immutable ref — assigned once, never edit)
 * Team: J. Brant Arseneau & the Mach33 Agents.
 */

import { readBootData } from '../shared/boot-data.js';
import { runShellHead } from '../shell/head.js';

// ── Start ────────────────────────────────────────────────────────────────
runShellHead(function () { return readBootData(document, 'm33-head-boot'); });
